export const getPharmaciesItems = (state) => state.pharmacies.pharmacies
export const getPharmaciesPagination = (state) => state.pharmacies.pagination
export const getIsLoadingPharmacies = (state) => state.pharmacies.isLoading